import { PropsWithChildren } from 'react';
import classNames from 'classnames';

type LabelProps = {
  htmlFor: string | undefined;
  className?: string;
};

const Label = ({ children, htmlFor, className }: PropsWithChildren<LabelProps>) => {
  if (!children) return null;
  return (
    <label
      htmlFor={htmlFor}
      className={classNames('capitalize text-sm text-slate-500 dark:text-slate-300', className)}
    >
      {children}
    </label>
  );
};

export default Label;
